import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isTokenValid } from '../helpers/jwt';
import { initAuthentication, refreshAccessToken, selectAccessToken } from '../store/authentication';

const REFRESH_TOKEN_INTERVAL = 60000;

/**
 * A hook that will ensure that there is a valid authenticated session and that it is kept alive.
 * If there is no session it will redirect to the authentication page.
 */
export const useAuthentication = (): string | undefined => {
    const dispatch = useDispatch<any>();
    const accessToken = useSelector(selectAccessToken);

    // A timer that keeps the token refreshed, including during demo mode -- the OAuth calls are intercepted
    // locally by oauthHandlers.ts in that case (except NO's real SBL exchange, which is deliberately passed
    // through). refreshAccessToken's own !refreshToken guard in authenticationStore.ts no-ops when there's
    // nothing to refresh, so this doesn't need its own conditional.
    useEffect(() => {
        const timer = setInterval(() => {
            dispatch(refreshAccessToken());
        }, REFRESH_TOKEN_INTERVAL);
        return () => clearInterval(timer);
    }, [dispatch]);

    useEffect(() => {
        if (!accessToken) {
            dispatch(initAuthentication());
        } else if (!isTokenValid(accessToken)) {
            dispatch(refreshAccessToken());
        }
    }, [accessToken, dispatch]);

    return accessToken;
};
